// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Header from "../Components/Header";
// import "./Orders.css";

// const Orders = () => {
//   const navigate = useNavigate();

//   const [orders, setOrders] = useState([]);
//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("All");

//   useEffect(() => {
//     const storedOrders = JSON.parse(localStorage.getItem("orders")) || [
//       {
//         id: "#ORD-1001",
//         customer: "Priya Sharma",
//         product: "Banarasi Silk Saree",
//         date: "2026-04-15",
//         amount: "₹12,500",
//         status: "Pending",
//         phone: "9876543210",
//         email: "priya@gmail.com",
//         address: "Nagpur, Maharashtra, India",
//         payment: "UPI Payment",
//         paymentId: "PAY123456",
//         image: "https://via.placeholder.com/60",
//       },
//       {
//         id: "#ORD-1002",
//         customer: "Ananya Gupta",
//         product: "Kanjivaram Saree",
//         date: "2026-04-14",
//         amount: "₹18,000",
//         status: "Shipped",
//         phone: "9988776655",
//         email: "ananya@gmail.com",
//         address: "Pune, Maharashtra, India",
//         payment: "Cash on Delivery",
//         paymentId: "COD789456",
//         image: "https://via.placeholder.com/60",
//       },
//     ];

//     setOrders(storedOrders);
//   }, []);

//   const filteredOrders = orders.filter((item) => {
//     const matchSearch =
//       item.id.toLowerCase().includes(search.toLowerCase()) ||
//       item.customer.toLowerCase().includes(search.toLowerCase()) ||
//       item.product.toLowerCase().includes(search.toLowerCase());

//     const matchStatus = statusFilter === "All" || item.status === statusFilter;

//     return matchSearch && matchStatus;
//   });

//   return (
//     <div className="orders-container">
//       <Header />

//       <div className="orders-header">
//         <div>
//           <h2>Orders</h2>
//           <p>Manage and track customer orders</p>
//         </div>
//       </div>

//       <div className="orders-filters">
//         <input
//           type="text"
//           placeholder="Search by order ID, customer, or product..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />

//         <select
//           value={statusFilter}
//           onChange={(e) => setStatusFilter(e.target.value)}
//         >
//           <option>All</option>
//           <option>Pending</option>
//           <option>Shipped</option>
//           <option>Delivered</option>
//         </select>
//       </div>

//       <div className="orders-table-box">
//         <table className="orders-table">
//           <thead>
//             <tr>
//               <th>Order ID</th>
//               <th>Customer</th>
//               <th>Product</th>
//               <th>Date</th>
//               <th>Amount</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>

//           <tbody>
//             {filteredOrders.map((item) => (
//               <tr key={item.id}>
//                 {/* ORDER ID CLICK */}
//                 <td
//                   className="orders-bold"
//                   style={{ cursor: "pointer" }}
//                   onClick={() =>
//                     navigate(`/order-details/${item.id.replace("#", "")}`, {
//                       state: item,
//                     })
//                   }
//                 >
//                   {item.id}
//                 </td>

//                 <td>{item.customer}</td>
//                 <td>{item.product}</td>
//                 <td>{item.date}</td>
//                 <td>{item.amount}</td>

//                 <td>
//                   <span
//                     className={`orders-status orders-${item.status.toLowerCase()}`}
//                   >
//                     {item.status}
//                   </span>
//                 </td>

//                 <td>
//                   <div className="orders-actions">
//                     {/* View */}
//                     <div
//                       className="orders-icon-btn"
//                       onClick={() => navigate(`/order-details/${item.id.replace("#", "")}`, {
//                       state: item,
//                     })}
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         height="24px"
//                         viewBox="0 -960 960 960"
//                         width="24px"
//                         fill="#4B77D1"
//                       >
//                         <path d="M607.5-372.5Q660-425 660-500t-52.5-127.5Q555-680 480-680t-127.5 52.5Q300-575 300-500t52.5 127.5Q405-320 480-320t127.5-52.5Zm-204-51Q372-455 372-500t31.5-76.5Q435-608 480-608t76.5 31.5Q588-545 588-500t-31.5 76.5Q525-392 480-392t-76.5-31.5ZM214-281.5Q94-363 40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200q-146 0-266-81.5ZM480-500Zm207.5 160.5Q782-399 832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280q113 0 207.5-59.5Z" />
//                       </svg>
//                     </div>

//                     {/* Edit */}
//                     <div
//                       className="orders-icon-btn"
//                       onClick={() =>
//                         navigate(`/order-details/${item.id.replace("#", "")}`, {
//                       state: item,
//                     })
//                       }
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         height="24px"
//                         viewBox="0 -960 960 960"
//                         width="24px"
//                         fill="#78A75A"
//                       >
//                         <path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z" />
//                       </svg>
//                     </div>
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default Orders;



import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Components/Header";
import "./Orders.css";
import axios from "axios";
import API_BASE from "../config";

const Orders = () => {
  const navigate = useNavigate();

  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);

      const token = sessionStorage.getItem("token");

      const response = await axios.get(
        `${API_BASE}/order/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedOrders = response.data.map((item) => ({
        orderDbId: item.id,

        id: item.orderNumber,
        customer: item.customerName,
        product: item.productName,

        date: new Date(item.orderDate).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }),

        amount: `₹${item.totalAmount?.toLocaleString()}`,

        status: item.status,

        phone: item.phone,
        email: item.email,
        address: item.address,

        payment: item.paymentMethod,
        paymentId: item.paymentId,

        image:
          item.image ||
          "https://via.placeholder.com/60",
      }));

      setOrders(formattedOrders);
    } catch (error) {
      console.log("Error fetching orders:", error);
    } finally {
      setLoading(false);
    }
  };

  const filteredOrders = orders.filter((item) => {
    const matchSearch =
      item.id?.toLowerCase().includes(search.toLowerCase()) ||
      item.customer?.toLowerCase().includes(search.toLowerCase()) ||
      item.product?.toLowerCase().includes(search.toLowerCase());

    const matchStatus =
      statusFilter === "All" || item.status === statusFilter;

    return matchSearch && matchStatus;
  });

  return (
    <div className="orders-container">
      <Header />

      <div className="orders-header">
        <div>
          <h2>Orders</h2>
          <p>Manage and track customer orders</p>
        </div>
      </div>

      <div className="orders-filters">
        <input
          type="text"
          placeholder="Search by order ID, customer, or product..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option>All</option>
          <option>Pending</option>
          <option>Shipped</option>
          <option>Delivered</option>
          <option>Cancelled</option>
        </select>
      </div>

      <div className="orders-table-box">
        <table className="orders-table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Customer</th>
              <th>Product</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" style={{ textAlign: "center" }}>
                  Loading orders...
                </td>
              </tr>
            ) : filteredOrders.length > 0 ? (
              filteredOrders.map((item) => (
                <tr key={item.orderDbId}>
                  {/* ORDER ID CLICK */}
                  <td
                    className="orders-bold"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate(`/order-details/${item.orderDbId}`, {
                        state: item,
                      })
                    }
                  >
                    {item.id}
                  </td>

                  <td>{item.customer}</td>

                  <td>{item.product}</td>

                  <td>{item.date}</td>

                  <td>{item.amount}</td>

                  <td>
                    <span
                      className={`orders-status orders-${item.status.toLowerCase()}`}
                    >
                      {item.status}
                    </span>
                  </td>

                  <td>
                    <div className="orders-actions">
                      {/* View */}
                      <div
                        className="orders-icon-btn"
                        onClick={() =>
                          navigate(`/order-details/${item.orderDbId}`, {
                            state: item,
                          })
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24px"
                          viewBox="0 -960 960 960"
                          width="24px"
                          fill="#4B77D1"
                        >
                          <path d="M607.5-372.5Q660-425 660-500t-52.5-127.5Q555-680 480-680t-127.5 52.5Q300-575 300-500t52.5 127.5Q405-320 480-320t127.5-52.5Zm-204-51Q372-455 372-500t31.5-76.5Q435-608 480-608t76.5 31.5Q588-545 588-500t-31.5 76.5Q525-392 480-392t-76.5-31.5ZM214-281.5Q94-363 40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200q-146 0-266-81.5ZM480-500Zm207.5 160.5Q782-399 832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280q113 0 207.5-59.5Z" />
                        </svg>
                      </div>

                      {/* Edit */}
                      <div
                        className="orders-icon-btn"
                        onClick={() =>
                          navigate(`/order-details/${item.orderDbId}`, {
                            state: item,
                          })
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24px"
                          viewBox="0 -960 960 960"
                          width="24px"
                          fill="#78A75A"
                        >
                          <path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z" />
                        </svg>
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{ textAlign: "center" }}>
                  No orders found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Orders;